import { render } from "./IconExpand.vue?vue&type=template&id=dd735eca"
import script from "./IconExpand.vue?vue&type=script&lang=js"
export * from "./IconExpand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__